import type { ProgressChartsProps } from './types';
import { ChartCarousel } from './ChartCarousel';
import { ProgressChart } from './ProgressChart';
import { ActivityChart } from './ActivityChart';
import { AnswerBreakdownChart } from './AnswerBreakdownChart';

export function OverviewProgressCharts({ sessions, isLoading }: ProgressChartsProps) {
  const charts = [
    { label: 'Progress', component: <ProgressChart sessions={sessions} includeAppName title="Overall Progress" /> },
    { label: 'Activity', component: <ActivityChart sessions={sessions} /> },
    { label: 'Answers', component: <AnswerBreakdownChart sessions={sessions} /> },
  ];

  return <ChartCarousel charts={charts} isLoading={isLoading} />;
}
